import { getFormattedFullAddress } from 'app/pages/loanApplication/LoanApplication.utils';

const PERCENTAGE = 100;

export const calculateAdvanceAmountPercent = ({ advanceAmount, addAdvanceAmount, wireAmount }) => {
  if (!wireAmount || Number(wireAmount) === 0) {
    return 0;
  }

  return (
    (((Number(advanceAmount) || 0) + (Number(addAdvanceAmount) || 0)) / Number(wireAmount)) *
    PERCENTAGE
  );
};

export const getFormValuesFromLocation = location => ({
  feeProviderLocationId: location.feeProviderLocationId,
  companyStreet: location.streetAddress,
  companyCity: location.city,
  companyState: location.state,
  companyZipCode: location.zipCode,
  bank: location.wireInformation?.bank,
  city: location.wireInformation?.city,
  state: location.wireInformation?.state,
  closingAgentABANumber: location.wireInformation?.abaNumber,
  closingAgentAccountNumber: location.wireInformation?.accountNumber,
  closingAgentFeeProviderFullAddress: getFormattedFullAddress({
    address: {
      street: location.streetAddress,
      city: location.city,
      state: location.state,
      zip: location.zipCode,
    },
  }),
  cityAndState: [location.wireInformation?.city, location.wireInformation?.state]
    .filter(Boolean)
    .join(', '),
});
